import {IOrganization} from "../../../organization/domain/interfaces/organization.interface";
import {IAudit} from "../../../../interfaces/audit.interface";
import {ITicketEvent} from "../../../ticket-events/interface/ticket-event.model";
import {Account} from "../../../account/domain/model/account.model";
import {Device} from "../../../device/models/device.model";

import {Drawer} from "@features/service/domain/models/drawer.model";
import {Worker} from "@features/service/domain/models/worker.model";

export class PaymentContext {
  constructor(
    public readonly drawer: Drawer,
    public readonly worker: Worker,
    public readonly organization: IOrganization,
    public readonly account: Account,
    public readonly audit: IAudit,
    public readonly ticketEvent: ITicketEvent,
    public readonly device: Device,
  ) {
  }
}
